import { createLucideIcon } from 'lucide-react';
export const StarIcon = createLucideIcon('star-icon', [
  [
    'path',
    {
      d: 'M12.2217 3.3418L12.2227 3.34473L14.6602 8.80566L14.7783 9.06836L15.0645 9.09863L21.0146 9.73047V9.73145L21.585 9.79395L21.1602 10.1729L21.1562 10.1758L16.7266 14.1836L16.5137 14.377L16.5732 14.6582L17.8154 20.5176V20.5186L17.9316 21.0645L17.4277 20.7764L12.251 17.7783L12 17.6328L11.749 17.7783L6.57227 20.7764L6.06738 21.0645L6.18457 20.5186V20.5176L7.42676 14.6582L7.48633 14.377L7.27344 14.1836L2.84375 10.1758L2.83984 10.1729L2.41406 9.79395L2.98438 9.73047L8.93555 9.09863L9.22168 9.06836L9.33984 8.80566L11.7773 3.34473L11.7783 3.3418L12 2.83691L12.2217 3.3418Z',
      key: '7u8mvq',
    },
  ],
]);
